// import "./styles/App.css";
import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'

import {
	HashRouter as Router, Navigate, Route, Routes} from "react-router-dom";

import { RootState } from "./redux/reducers/root";
import { generateRoutes } from "./routes";
import { TokenState } from "./redux/reducers/getAuthReducer/tokenReducer";
import { setToken } from "./redux/actions/auth/token";
import ToastNotification from "./components/common/ToastNotification/ToastNotification";
import AmpModal from "./components/common/AmpModal/AmpModal";
import { setSessionExpiry, setSessionExpiryWarning } from "./utils/helperFunction";
import PopUpToast from "./components/common/ToastNotification/PopUpToast";
import ScrollToTop from "./components/ScrollTop/ScrollTop";
import StatusBar from "./components/StatusBar/StatusBar";
import { isAmppa } from "./utils/isAmppa";
import RefreshUi from "./components/login/Refresh/RefreshUi";
import { changeIsCloseable, changeModalContent, changeModalState } from "./redux/actions/modal/modal";
import { useTranslation } from "react-i18next";
import AppDown from "./components/landing/AppDown/AppDown.module";

function App(): JSX.Element {


	const { t } = useTranslation("landing");

	const [auth, setAuth] = useState(false);
	const [pierPortal, setPierPortal] = useState(false);
	const [tocAccepted, setTocAccepted] = useState(false);
	const [sessionExpired, setSessionExpired] = useState(false);
	const [verify, setVerify] = useState(false);

	const dispatch = useDispatch();

	const tokenStore = useSelector((state: RootState) => state.authReducer.token as TokenState);

	const storageKey = "amptoken";
	const storageToken = localStorage.getItem(storageKey);
	const verifyInfo = localStorage.getItem("verifyInfo");

	const showMaintainencePage = process.env?.REACT_APP_SHOW_DOWN_PAGE === "1";

	if (verifyInfo) {
		if (!verify){
			setVerify(true);
		}		
	} else {
		if (verify){
			setVerify(false);
		}
	}

	if(storageToken && tokenStore.tokenSet) {
		if (!auth){
			setAuth(true);
		}
	} else 	if (storageToken != null && !tokenStore.tokenSet) {
		dispatch(setToken(true));
	} else {
		if (auth) {
			setAuth(false);
		}
	}

	const storageShowSplash = localStorage.getItem("ampSplash");
	if (storageShowSplash === "true") {
		if (!pierPortal) {
			setPierPortal(true);
		}
	} else {
		if (pierPortal) {
			setPierPortal(false);
		}
	}

	if ( isAmppa ) {
		if (!tocAccepted) {
			setTocAccepted(true);
			localStorage.setItem("acceptedToc", "yes");
		}
		
	} else {
		const storageTocAccepted = localStorage.getItem("acceptedToc");
		if (storageTocAccepted) {
			if (!tocAccepted) {
				setTocAccepted(true);
			}
		} else {
			if (tocAccepted) {
				setTocAccepted(false);
			}
		}
	}


	const timeLeft = setSessionExpiry();
	const timeToWarning = setSessionExpiryWarning();
	const showSessionExtensionModal = () => {
		dispatch(changeModalState("modal-fade-in"));
		dispatch(changeIsCloseable(false));
		dispatch(changeModalContent(<RefreshUi/>, t("refresh.1")))
		return;
	}


	if(process.env.REACT_APP_REFRESH_ENABLED){
		if(tokenStore.tokenSet){
			if (timeToWarning <= 0) {
				// Show modal for refreshing token
				showSessionExtensionModal();
			} else {
				setTimeout(() => {
					showSessionExtensionModal();
				}, timeToWarning );
			}
		}
	} 
	if (timeLeft <= 0) {
		if (!sessionExpired) {
			setSessionExpired(true);
		}
	} else {
			if (sessionExpired) {
				setSessionExpired(false);
			}
			setTimeout(() => {
				setSessionExpired(true);
			}, timeLeft );
	}

	if(showMaintainencePage) {
		dispatch(changeModalState("modal-fade-in"));
		dispatch(changeIsCloseable(false));
		dispatch(changeModalContent(<AppDown/>, "Maintenance"))
	}
	

	const routes = generateRoutes(auth, tocAccepted, sessionExpired);
	return (
		<>
			<main>
				<StatusBar/>
				<Router>
					<ScrollToTop />
					<Routes>
						{routes}
						<Route
							path="*"
							element={!auth ?
								(!verify ? <Navigate to="/auth/home" /> : <Navigate to={`/auth/verify/${verifyInfo}`} />) :
									sessionExpired ?
										<Navigate to="/amp/signout" /> :
										!tocAccepted ?
											<Navigate to="/toc" /> :
											pierPortal ? 
												<Navigate to="/pierportal" /> :
												<Navigate to="/amp" />
									
							}
						/>
					</Routes>
					<AmpModal />
				</Router>
				<ToastNotification />
				<PopUpToast/>
			</main>
		</>
	)
}

export default App;
